import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

// constants
import { app } from 'config/app.config';

// services
import { NavigationService } from '@sideline/sideline-apps-shared';

// components
import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.html',
  styleUrl: './public-header.scss',
  standalone: true,
  imports: [
    ButtonModule,
    StyleClassModule,
    RouterLink,
],
})
export class PublicHeader {

  @Input() display!: boolean;

  // component
  appName: string = app.marketing.names.product;
  marketingSite: string = app.marketing.site;
  title: string = this.appName;

  // services
  private navService = inject(NavigationService);

  // ==========================================================================================================================
  //  Actions
  // ==========================================================================================================================

  navigateToRegistration() {
    this.navService.signUp();
  }

  signIn(): void {
    const redirectUrl = window.location.origin + '/dashboard';
    this.navService.signIn(redirectUrl);
  }

}
